<template>
  <LayoutDefault>
    <h1>Seu Perfil</h1>
    <p class="text-sm text-gray-500 leading-tight font-light text-center">
      Aqui você pode alterar a senha ou seu nome. Para alterar o email, fale com
      a gente!
    </p>
    <div class="beto"></div>

    <ValidationErrors
      :errors="validationErrors"
      v-if="validationErrors"
    ></ValidationErrors>

    <div class="auth-body">
      <div class="auth-form">
        <form v-on:submit.prevent>
          <label for="name">Nome</label>
          <input id="name" type="text" v-model="name" autocomplete="name" />
          <label for="email">Email</label>
          <input
            id="email"
            type="text"
            v-model="email"
            autocomplete="email"
            disabled
            class="text-gray-500"
          />
          <label class="mt-16" for="password">Nova Senha</label>
          <input
            id="password"
            type="password"
            v-model="password"
            autocomplete="new-password"
          />
          <label for="password-confirmation">Confirmação de Senha</label>
          <input
            id="password-confirmation"
            type="password"
            v-model="password_confirmation"
            autocomplete="new-password"
          />
          <button
            @click="handleClickChangeData"
            class="mt-10 button button-primary"
          >
            Alterar Dados
          </button>
        </form>
      </div>
    </div>
  </LayoutDefault>
</template>

<script>
import axios from "../axiosClient";
import LayoutDefault from "../layouts/LayoutDefault";
import ValidationErrors from "./ValidationErrors";
export default {
  name: "UserProfile",
  components: { LayoutDefault, ValidationErrors },
  data() {
    return {
      name: this.$store.state.user.name,
      password: "",
      email: this.$store.state.user.email,
      password_confirmation: "",
      validationErrors: ""
    };
  },
  methods: {
    handleClickChangeData() {
      this.validationErrors = "";
      axios
        .put(`users/${this.$store.state.user.id}`, {
          name: this.name,
          password: this.password,
          password_confirmation: this.password_confirmation
        })
        .then(() => {
          this.$store.dispatch("fetchUser");
          this.$toasted.success("Maravilha! Dados Atualizados", {
            icon: "done_outline"
          });
        })
        .catch(error => {
          this.$toasted.error("Ops... parece que deu alguma coisa errada...");

          if (error.response.status === 422) {
            this.validationErrors = error.response.data.errors;
          }
        });
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
h1 {
  text-align: left;
  font-size: 30px;
  font-weight: 500;
}
p {
  text-align: left;
}
</style>
